export {default} from 'views/TradingAccountsReport/TradingAccountsReport'


// WEBPACK FOOTER //
// ./src/views/Reports/TradingAccountsReport.jsx